export default function ModKeyChar() {
  const isMac = navigator.userAgent.includes("Macintosh");
  return <>{isMac ? "⌘" : "Ctrl"}</>;
}
